import { FC } from 'react'

import styled from 'styled-components'
import InfiniteScroll from 'react-infinite-scroll-component'
import { Loader } from '@mantine/core'

import { TableLoading } from 'src/Components/TableLoading'
import { NoDataMessage } from 'src/Components/NoDataMessage'
import { Pagination } from 'src/Helpers/types.ts'
import { ManagedUser } from 'src/Redux/api/usersApi.ts'

import { UserItem } from './UserItem.tsx'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
  flex: 1;
  min-height: 0;
`

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-bottom: 16px;
`

const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`

const LoaderWrapper = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
`

type UsersTableProps = {
  users?: ManagedUser[]
  isLoading: boolean
  onEditUser: (user: ManagedUser) => void
  onArchiveUser: (id: number) => void
  onRestoreUser: (id: number) => void
  currentUserId?: number
} & Pagination

export const UsersTable: FC<UsersTableProps> = ({
  users,
  isLoading,
  onEditUser,
  onArchiveUser,
  onRestoreUser,
  onLoadMore,
  hasNextPage,
  currentUserId,
}) => {
  if (isLoading) {
    return (
      <ListWrapper>
        <TableLoading />
      </ListWrapper>
    )
  }

  if (users?.length === 0) {
    return (
      <ListWrapper>
        <NoDataMessage />
      </ListWrapper>
    )
  }

  return (
    <Container>
      <ListWrapper id='scrollableUsersDiv'>
        <InfiniteScroll
          scrollableTarget={'scrollableUsersDiv'}
          dataLength={users?.length || 0}
          next={onLoadMore}
          hasMore={Boolean(hasNextPage)}
          loader={
            <LoaderWrapper>
              <Loader color='blue' />
            </LoaderWrapper>
          }
        >
          <ItemsContainer>
            {users?.map((user) => (
              <UserItem
                key={user.id}
                user={user}
                onEditItem={onEditUser}
                onArchiveItem={onArchiveUser}
                onRestoreItem={onRestoreUser}
                currentUserId={currentUserId}
              />
            ))}
          </ItemsContainer>
        </InfiniteScroll>
      </ListWrapper>
    </Container>
  )
}
